export default __webpack_public_path__ + "img/mute.2056bb7e.svg";